import { IdentifiedSymptomManagement } from '@/components/identified-symptom/IdentifiedSymptomManagement';
import { RecommendationManagement } from '@/components/recommendation/RecommendationManagement';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export const IdentifiedSymptomPage = () => {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Symptômes identifiés</h1>
      <Tabs defaultValue="food-supplements">
        <TabsList className="mb-6">
          <TabsTrigger value="food-supplements">
            Symptômes → Compléments
          </TabsTrigger>
          <TabsTrigger value="recommendations">
            Symptômes → Recommandations
          </TabsTrigger>
        </TabsList>

        <TabsContent value="food-supplements">
          <IdentifiedSymptomManagement />
        </TabsContent>

        <TabsContent value="recommendations">
          <RecommendationManagement />
        </TabsContent>
      </Tabs>
    </div>
  );
};
